module.exports = __webpack_public_path__ + "img/mustata-only.3db212cf.png";